const setShowFloatMenuAction = ({ commit }, payload: boolean): void => {
  commit("setShowFloatMenu", payload);
};
const setManageSpaceAction = ({ commit }, payload: boolean): void => {
  commit("setManageSpace", payload);
};
const setOpenProfileAction = ({ commit }, payload: boolean): void => {
  commit("setOpenProfile", payload);
};
const setOpenProfileSocialAction = ({ commit }, payload: boolean): void => {
  commit("setOpenProfileSocial", payload);
};
const setOpenEmojiSelectorAction = ({ commit }, payload: boolean): void => {
  commit("setOpenEmojiSelector", payload);
};
const setOpenConsoleMessageAction = ({ commit }, payload: boolean): void => {
  commit("setOpenConsoleMessage", payload);
};
const setOpenConsoleMessageMultiSpaceAction = (
  { commit },
  payload: boolean
): void => {
  commit("setOpenConsoleMessageMultiSpace", payload);
};
const setOpenHelpBotAction = ({ commit }, payload: boolean): void => {
  commit("setOpenHelpBotAction", payload);
};

const setOpenReasonSelectorAction = ({ commit }, payload: boolean): void => {
  commit("setOpenReasonSelector", payload);
};

const setShowNextMaintenanceAction = ({ commit }, payload) => {
  commit("setShowNextMaintenance", payload);
};

const setTimeNextMaintenanceAction = ({ commit }, payload) => {
  commit("setTimeNextMaintenance", payload);
};

const setOpenCalendarModalAction = ({ commit }, payload) => {
  commit("setOpenCalendarModal", payload);
};

const setOpenChangeSpaceSelectorAction = ({ commit }, payload: boolean): void => {
  commit("setOpenChangeSpaceSelector", payload);
};
export default {
  setShowFloatMenuAction,
  setManageSpaceAction,
  setOpenProfileAction,
  setOpenEmojiSelectorAction,
  setOpenConsoleMessageAction,
  setOpenHelpBotAction,
  setOpenReasonSelectorAction,
  setShowNextMaintenanceAction,
  setTimeNextMaintenanceAction,
  setOpenConsoleMessageMultiSpaceAction,
  setOpenCalendarModalAction,
  setOpenChangeSpaceSelectorAction,
  setOpenProfileSocialAction,
};
